// extracted by mini-css-extract-plugin
module.exports = {"advanced-configuration-title":"settings_advanced-configuration-title__2gUu_","advanced-configuration-subtitle":"settings_advanced-configuration-subtitle__2l5o0"};